import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_VMS_URL

export const _get = async (vendorId, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/vendor/${vendorId}/contract`,
    params,
  })

  return response?.data
}

// Create function generator, this returned function
// will be passed to McTable with vendorId already set
export const getByVendorId = (vendorId) => async (queryParam) => await _get(vendorId, queryParam)
